module.exports = __webpack_public_path__ + "img/Car.7a81acb2.svg";